module.exports = "<a class=\"cursor-pointer\" [ngClass]=\"{'mat-accent': userSlug}\" (click)=\"openDialog()\">{{ userName }}</a>\n";